import { _decorator, EventTarget, Component, Material, log, UIRenderer } from 'cc';
import { DEV } from 'cc/env';
import Delay from '../../Utils/Delay';

const { ccclass, property, requireComponent } = _decorator;

enum EventType {
    MATERIAL_UPLOADED = 'MATERIAL_UPLOADED',
}

@ccclass('SharedMaterial')
@requireComponent(UIRenderer)
export default class SharedMaterial extends Component {
    public static readonly EVENT_TYPE = EventType;

    public static event: EventTarget = new EventTarget();

    private static _materials: Map<string, Material> = new Map<string, Material>();

    @property({ tooltip: DEV && '1. 有 UV/Position LRTBProbider 的不適用 (跟取樣有關)\n2. 相同設定使用相同tag名稱，且只需掛 SharedMaterial 即可' })
    public tag: string = '';

    private _uiRenderer: UIRenderer = null;

    public static save(tag: string, material: Material) {
        if (this._materials.get(tag)) {
            log(`Material: ${tag} is exist and won't overwrite it.`);
            return;
        }
        material.serialize();
        this._materials.set(tag, material);
        this.event.emit(this.EVENT_TYPE.MATERIAL_UPLOADED, tag);
    }

    public static get(tag: string) {
        return this._materials.get(tag);
    }

    public async onLoad() {
        this._uiRenderer = this.getComponent(UIRenderer);
        if (this.tag) {
            this._uiRenderer.customMaterial = this.getMaterial();
            // this.setMaterial();
        }
    }

    protected getMaterial() {
        const settingMaterial = new Material();
        let usingMaterial = SharedMaterial.get(this.tag);
        if (!usingMaterial) {
            if (this._uiRenderer?.customMaterial) {
                settingMaterial.copy(this._uiRenderer.customMaterial);
                usingMaterial = settingMaterial;
                SharedMaterial.save(this.tag, usingMaterial);
            } else {
                Delay.event(SharedMaterial.EVENT_TYPE.MATERIAL_UPLOADED, SharedMaterial.event, (tag: string) => this.tag === tag).then(() => {
                    this._uiRenderer.customMaterial = SharedMaterial.get(this.tag);
                });
            }
        }
        return usingMaterial;
    }

    // 因跟上面的 getMaterial 基本上一樣，不確定有沒有用，註解掉後看起來正常，先保留
    // protected setMaterial() {
    //     const settingMaterial = new Material();
    //     let usingMaterial = SharedMaterial.get(this.tag);
    //     if (usingMaterial) {
    //         this._uiRenderer.customMaterial = usingMaterial;
    //     } else if (this._uiRenderer?.customMaterial) {
    //         settingMaterial.copy(this._uiRenderer.customMaterial);
    //         usingMaterial = settingMaterial;
    //         SharedMaterial.save(this.tag, usingMaterial);
    //     } else {
    //         Delay.event(SharedMaterial.EVENT_TYPE.MATERIAL_UPLOADED, SharedMaterial.event, (tag: string) => this.tag === tag).then(() => {
    //             this._uiRenderer.customMaterial = SharedMaterial.get(this.tag);
    //         });
    //     }
    // }
}
